import React from 'react';
import TopicCard from './TopicCard';
import { getRelatedTopics } from '../../data/businessPlaybookContent';

const KeepLearningRow = ({ currentTopicSlug }) => {
  const relatedTopics = getRelatedTopics(currentTopicSlug);

  if (relatedTopics.length === 0) {
    return null;
  }

  return (
    <div className="mt-12 pt-8 border-t border-gray-200">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Keep Learning</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {relatedTopics.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </div>
  );
};

export default KeepLearningRow;
